// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";

const description =
  "Fill in the categories and the nominees for any awards show and tick the winner once announced.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Awards module",
  id: "awards-embed",
  groupsWithAccess: ["specialist_user", "editor_user"],
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/awards-table/?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "AwardsEmbedConfigTool" */ "app/components/tools/AwardsEmbedConfigTool/AwardsEmbedConfigTool"),
    loading: DynamicImportLoader,
    modules: ["AwardsEmbedConfigTool"]
  })
};

export default CONFIG;
